"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const complex_data_1 = require("complex-data");
class CascaderList extends complex_data_1.SelectList {
    constructor(initOption) {
        super(initOption);
        this.cascader = 'children';
    }
    _getCascadeList(list, value, prop, index = 0, result = []) {
        const currentValue = value[index];
        for (let n = 0; n < list.length; n++) {
            const item = list[n];
            if (this.check(currentValue, item[prop])) {
                result.push(item);
                if (item[this.cascader] && index < value.length - 1) {
                    this._getCascadeList(item[this.cascader], value, prop, index + 1, result);
                }
                break;
            }
        }
        return result;
    }
    getCascadeList(valueList, prop = 'value') {
        return this._getCascadeList(this.list, valueList, prop);
    }
}
exports.default = CascaderList;
